/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type TimeZoneCode = typeof TimeZoneCode[keyof typeof TimeZoneCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TimeZoneCode = {
  LONDON: 'LONDON',
  PARIS: 'PARIS',
  ATHENS: 'ATHENS',
  MOSCOW: 'MOSCOW',
  SINGAPORE: 'SINGAPORE',
  TOKYO: 'TOKYO',
  SYDNEY: 'SYDNEY',
  ADELAIDE: 'ADELAIDE',
  DARWIN: 'DARWIN',
  AUCKLAND: 'AUCKLAND',
  BUENOS_AIRES: 'BUENOS_AIRES',
  NEW_YORK: 'NEW_YORK',
  CHICAGO: 'CHICAGO',
  DENVER: 'DENVER',
  LOS_ANGELES: 'LOS_ANGELES',
  JUNEAU: 'JUNEAU',
  HONOLULU: 'HONOLULU',
  FAKAOFO: 'FAKAOFO',
  SHANGHAI: 'SHANGHAI',
  HO_CHI_MINH: 'HO_CHI_MINH',
  DHAKA: 'DHAKA',
  KARACHI: 'KARACHI',
  YEREVAN: 'YEREVAN',
  ADIS_ABABA: 'ADIS_ABABA',
  CAIRO: 'CAIRO',
} as const;
